// @ai-generated 2026-08-05T00:00:00+00:00 by malte.ulfers@tngtech.com using Claude Opus 4.7
export function formatLiteral(value: unknown): string {
    if (value === null || value === undefined) return '∅';
    if (typeof value === 'string') return `"${value}"`;
    return String(value);
}
